module.exports = __webpack_public_path__ + "static/topic-1-a9f6b7626d44bc88598d6e7d24c44343.jpg";